<template>
  <footer>
    <p>Source: BLS.gov</p>
  </footer>
</template>

<script>
export default {};
</script>


// WEBPACK FOOTER //
// src/components/Footer.vue